var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTramStop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34951",
    "data-name": "Group 34951",
    transform: "translate(-4943 -5405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(4943 5405)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34865",
    "data-name": "Group 34865",
    transform: "translate(4959.967 5422.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34893",
    "data-name": "Group 34893",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24357",
    "data-name": "Path 24357",
    d: "M22.562,11.114V7.379H18.374c0,.34.015.656,0,.97a.879.879,0,0,1-.842.9.833.833,0,0,1-.908-.818,14.021,14.021,0,0,1,0-2.011c.044-.584.389-.826,1.055-.827,2-.006,4,0,6,0q2.9,0,5.8,0c.872,0,1.171.305,1.179,1.189,0,.471.011.941,0,1.412-.02.674-.353,1.055-.9,1.057s-.876-.393-.888-1.059c0-.252,0-.5,0-.8H24.695v3.7c.164.01.342.026.522.026.907,0,1.816.031,2.722,0a6.037,6.037,0,0,1,6.467,5.465c.3,2.093.7,4.172,1.04,6.259a7.578,7.578,0,0,1,.118,1.2c.008,2.6.071,5.212-.017,7.814A5.824,5.824,0,0,1,29.5,37.643c-.43,0-.859,0-1.4,0l4,5.4c-.672,0-1.243,0-1.815,0a.216.216,0,0,1-.159-.106c-.231-.517-.685-.441-1.117-.441q-5.546,0-11.094,0a.706.706,0,0,0-.72.332.458.458,0,0,1-.3.221c-.547.023-1.095.011-1.759.011l4-5.412c-.5,0-.906,0-1.31,0a5.98,5.98,0,0,1-3.655-1.089,5.7,5.7,0,0,1-2.49-4.767c-.018-2.773-.078-5.551.07-8.315a48.545,48.545,0,0,1,.822-5.269c.132-.794.271-1.587.428-2.377a5.883,5.883,0,0,1,6.008-4.715c.991.019,1.983,0,2.975,0h.575m.99,12.733h1.965c1.764,0,3.528,0,5.293,0,1.06,0,1.489-.527,1.31-1.571-.309-1.8-.611-3.6-.922-5.407a3.34,3.34,0,0,0-3.48-2.979q-4.108-.02-8.215,0a3.332,3.332,0,0,0-3.453,2.95q-.465,2.7-.921,5.408c-.19,1.12.218,1.6,1.369,1.6q3.526,0,7.055,0m-5.635,9.5h1.511a.815.815,0,0,0,.89-.872c.02-.569.02-1.141,0-1.712a.8.8,0,0,0-.882-.872q-1.535-.025-3.071,0a.8.8,0,0,0-.872.84,15.811,15.811,0,0,0,0,1.76.823.823,0,0,0,.916.853c.5.013,1.007,0,1.509,0m11.42,0c.5,0,1.007.011,1.509,0a.806.806,0,0,0,.9-.815,15.35,15.35,0,0,0,0-1.811.8.8,0,0,0-.883-.827q-1.535-.023-3.071,0a.783.783,0,0,0-.866.833c-.023.587-.023,1.175,0,1.761a.806.806,0,0,0,.9.858c.5.013,1.007,0,1.511,0m-10.8,7.7H28.707c-.313-.424-.562-.8-.852-1.14a.682.682,0,0,0-.453-.216q-3.78-.02-7.557,0a.569.569,0,0,0-.4.135c-.307.372-.579.771-.912,1.224m8.031-2.8a.812.812,0,0,0-.906-.613c-1.376.029-2.754.031-4.13,0a.792.792,0,0,0-.859.614Zm-1.349-7H22.033V32h3.185Z",
    transform: "translate(-3.623 -4.668)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTramStop);
export default __webpack_public_path__ + "static/media/tramStop.a1597bdcfae23e569064dae01bfe881d.svg";
export { ForwardRef as ReactComponent };